import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import ContractRevenueCalculator from '../../../features/closures/components/ContractRevenueCalculator';
// import { useWorkspaceContext } from '../../../context/WorkspaceContext';
import ConfigMapingFormPage from '../configSubmissionForm/configMappingForm';
// import ConfigSubmissionFormPage from '../configSubmissionForm/configSubmissionForm';
import ConfigSubmissionFormPageNew from '../customizeSubmissionFlow/configSubmissionFormNew';
import SubmissionEmailTemplate from '../customizeSubmissionFlow/submissionEmailTemplate';
import SubmissionTemplates from '../customizeSubmissionFlow/submissionTemplates';
import DataDownloadSettings from '../dataDownloadSettings/DataDownloadSettings';
import EvaluationTemplate from '../EvaluationTemplate';
import InformationCategories from '../InformationCategories';
import ManageCandidateResponse from '../ManageCandidateResponse/ManageCandidateResponse';
// import ManageRecruiterActions from '../ManageRecruiterActions/ManageRecruiterActions';
import ManageRecruiterActionsNew from '../ManageRecruiterActions/ManageRecruiterActionsNew';
import PaginationSettingsPage from '../paginationSettings/paginationSettingsPage';
import RTRTemplate from '../RTRTemplate';
import StageStatusSettings from '../StageStatusSettings';

export const CrmConfigSubmissionRoutes = () => (
  <Routes>
    <Route
      path="/configure-submission-form"
      element={
        <RouteWithTitle title="Configure Submission Forms - Wisestep">
          <ConfigSubmissionFormPageNew />
        </RouteWithTitle>
      }
    />
    <Route
      path="/configure-mapping-form"
      element={
        <RouteWithTitle title="Configure Mapping Forms - Wisestep">
          <ConfigMapingFormPage />
        </RouteWithTitle>
      }
    />
    <Route
      path="/configure-submission-flow/*"
      element={
        <RouteWithTitle title="Configure Submission Flow - Wisestep">
          <SubmissionTemplates />
        </RouteWithTitle>
      }
    />
    <Route
      path="/configure-submission-email-template/*"
      element={
        <RouteWithTitle title="Configure Submission Email Template - Wisestep">
          <SubmissionEmailTemplate />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const PaginationSettingsRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Pagination Settings - Wisestep">
          <PaginationSettingsPage />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const DataDownloadSettingsRoutes = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <RouteWithTitle title="">
          <DataDownloadSettings />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const StageStatusRoutes = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <RouteWithTitle title="Customize Stage Status - Wisestep">
          <StageStatusSettings type="stage" />
        </RouteWithTitle>
      }
    />
    <Route
      path="/business-definition"
      element={
        <RouteWithTitle title="Customize Business Definition - Wisestep">
          <StageStatusSettings type="business" />
        </RouteWithTitle>
      }
    />
    <Route
      path="/submission"
      element={
        <RouteWithTitle title="Customize Submission Stage Status - Wisestep">
          <StageStatusSettings type="submission" />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const ManageRecruiterActionRoute = () => {
  // const workspace = useWorkspaceContext();

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <RouteWithTitle title="Manage Recruiter Actions - Wisestep">
            {/* {workspace.id === '0ed56aea-54c9-4485-987f-ffb35872eb38' ||
            workspace.id === '352f4535-62a5-4d74-8019-cb2ea76d8cb5' ? ( */}
            <ManageRecruiterActionsNew />
            {/* ) : (
              <ManageRecruiterActions />
            )} */}
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
export const ManageCandidateResponseRoute = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <RouteWithTitle title="Manage Candidate Response - Wisestep">
          <ManageCandidateResponse />
        </RouteWithTitle>
      }
    />
  </Routes>
);
export const EvaluationTemplateRoute = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Evaluation Template - Wisestep">
          <EvaluationTemplate />
        </RouteWithTitle>
      }
    />
  </Routes>
);
export const InformationCategoriesRoute = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Information Categories - Wisestep">
          <InformationCategories />
        </RouteWithTitle>
      }
    />
  </Routes>
);
export const RTRTemplateRoute = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="RTR Template - Wisestep">
          <RTRTemplate />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const RevenueCalculator = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Revenue Calculator - Wisestep">
          <ContractRevenueCalculator />
        </RouteWithTitle>
      }
    />
  </Routes>
);
